import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { TeiHubLinkOrderModel } from "features/hublink/core/domain/tei-hub-link.model";
import {
  GetTeiHubLinkOrderResponse,
  GetTeiHubLinkOrderRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkOrder {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkOrder;
  message: string;
  data: TeiHubLinkOrderModel | undefined;
}

const initialState: InitialState = {
  status: TeiHubLinkOrder.initial,
  message: "",
  data: undefined,
};

export const teiHubLinkOrder = createAsyncThunk(
  "teiHubLinkOrder",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkOrderResponse =
        await GetTeiHubLinkOrderRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkOrderSlice = createSlice({
  name: "teiHubLinkOrder",
  initialState,
  reducers: {
    resetTeiHubLinkOrder: (state) => {
      state.status = TeiHubLinkOrder.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkOrder.pending, (state) => {
        state.status = TeiHubLinkOrder.inProgress;
      })
      .addCase(teiHubLinkOrder.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = TeiHubLinkOrder.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(teiHubLinkOrder.rejected, (state, action) => {
        state.status = TeiHubLinkOrder.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectTeiHubLinkOrder = (state: RootState) =>
  state.teiHubLinkOrder;

export const { resetTeiHubLinkOrder } = teiHubLinkOrderSlice.actions;
export default teiHubLinkOrderSlice.reducer;
